import Vue from 'vue'
import Vuex from 'vuex'
// chamadas a API
import requests from "../requests/index";
// constantes do sistema
import constants from "../constants/index";
import helpers from "@/helpers";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        count: 0,
        count_alert: 0,
        requests: requests,
        constants: constants,
        breadcrumb_voltar: false,
        breadcrumb_previnir: false,
        ind_gravacao: false,
        filtroPesquisa: {},
        resultadoPesquisa: {},
        mensagensAlert: []
    },
    mutations: {
        increment(state) {
            state.count++
        },
        breadcrumb_voltar(state, value){
            state.breadcrumb_voltar = value;
        },
        breadcrumb_previnir(state, value){
            state.breadcrumb_previnir = value;
        },
        count_alert(state, value) {
            state.count_alert = value;
        },
        ind_gravacao(state, value) {
            state.ind_gravacao = value;
        },
        setFiltroPesquisa(state, filtroPesquisa) {
            state.filtroPesquisa = filtroPesquisa;
        },
        setResultadoPesquisa(state, resultadoPesquisa) {
            state.resultadoPesquisa = resultadoPesquisa;
        },
        setMensagensAlert(state, mensagem) {
            if(mensagem){
                if(!state.mensagensAlert.includes(mensagem)){
                    state.mensagensAlert.push(mensagem);
                }
                helpers.scrollToTop();
            }else{
                state.mensagensAlert = []; 
            }
        },
    },
    actions: {
        ind_gravacao(context, value){
            context.commit('ind_gravacao', value ? true : false)
        }
    },
    getters: {
        http: state => state.requests,
        const: state => state.constants,
        count_alert: state => state.count_alert,
        breadcrumb_voltar: state => state.breadcrumb_voltar,
        breadcrumb_previnir: state => state.breadcrumb_previnir,
        ind_gravacao: state => state.ind_gravacao,
        filtroPesquisa: (state) =>  state.filtroPesquisa,
        resultadoPesquisa: (state) =>  state.resultadoPesquisa,
        mensagensAlert: (state) =>  state.mensagensAlert,
    }
})
